// ── Info banners + personal messages contract (REQ-22) ──────────────────────
// Receive-side ONLY: authoring/targeting is back-office. This repo fetches,
// renders, and dismisses. SIGNATURES UNCHANGED from the mock contract — the
// backend was written to match these exactly.
import { apiClient } from 'src/api/client';
import { sleep } from 'src/api/_mock/util';

export type BannerSeverity = 'info' | 'warning' | 'success' | 'critical';

export type InfoBanner = {
  id: string;
  severity: BannerSeverity;
  title: string;
  body: string;
  linkLabel?: string;
  linkUrl?: string;
  dismissible: boolean;
  /** ISO. The server should already filter by the active window; the FE
   *  re-guards client-side as belt-and-braces. */
  startsAt: string;
  endsAt?: string;
};

export async function getActiveBanners(input: {
  userId: string;
  propertyId?: string;
}): Promise<InfoBanner[]> {
  return (
    await apiClient.get('comms/banners', {
      params: { user_id: input.userId, property_id: input.propertyId },
    })
  ).data;
}

export async function dismissBanner(input: {
  userId: string;
  bannerId: string;
}): Promise<void> {
  await apiClient.post(`comms/banners/${input.bannerId}/dismiss`, {
    user_id: input.userId,
  });
}

// Per-user personal messages — stub-only for now (Phase 5 owns real messaging).
// Kept so an unread badge / inbox popover is cheap to add later.
export type PersonalMessage = {
  id: string;
  subject: string;
  body: string;
  createdAt: string;
  read: boolean;
};

export async function getPersonalMessages(input: {
  userId: string;
}): Promise<PersonalMessage[]> {
  // Real: return (await apiClient.get('comms/messages', { params: { user_id: input.userId } })).data;
  await sleep(150);
  void input;
  return [];
}

export async function markMessageRead(input: {
  userId: string;
  messageId: string;
}): Promise<void> {
  // Real: await apiClient.post(`comms/messages/${input.messageId}/read`, { user_id: input.userId });
  await sleep(80);
  void input;
}
